document.addEventListener('DOMContentLoaded', () => {
    // DOM Element References
    const storagekey = 'noSubscribe';
    const modalElement = document.getElementById('emailSubModal');
    const checkbox = document.getElementById('securityAlertCheckbox');
    const websiteGroup = document.getElementById('websiteInputGroup');
    const websiteInput = document.getElementById('websiteInput');
    const form = document.getElementById('subscriptionForm');
    const submitButton = document.getElementById('emailSubSubmit'); 
    const modal = $(modalElement).modal({
            backdrop: 'static',
            storagekeyboard: false,
            show: false
        });

    // --- URL Parameter Checks ---
    const url = new URL(window.location);
    const email = url.searchParams.get('email');
    const website = url.searchParams.get('website');
    const optin = email && url.searchParams.has('subscribed') && !url.searchParams.get('subscribed'); //used to force the modal open
    


    // 1. Set Modal Content (Title and Text)
    
    if (optin) {
        $(".optin").show();
        $(".subscr").hide();
        $("#emailInput").val(email);
        $("#emailInwebsiteInputput").val(website);
        $('#emailSubEmail').text(email);
        //Give time to all lib to use the params
        setTimeout(() => {
            url.searchParams.delete('email');
            url.searchParams.delete('website');
            url.searchParams.delete('subscribed');
            history.replaceState(null, '', url.toString());
        }, 5000)
    } else {
        $(".subscr").show();
        $(".optin").hide();
    }
    $(websiteGroup).hide()

    // 2. Toggle Website Input based on Checkbox
    checkbox.addEventListener('change', () => {
        const isChecked = checkbox.checked;
        isChecked ? $(websiteGroup).show(800) : $(websiteGroup).hide(800);
        websiteInput.required = isChecked; 
        
        // Clear validation state if the user unchecks the box
        if (!isChecked) {
            websiteInput.classList.remove('is-invalid');
            websiteInput.value = ''; // Optional: clear value when hidden
        }
    });

    // 3. Handle Button Click Submission (Replaces form submit)
    if (submitButton) {
       
        submitButton.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            // Manually trigger Bootstrap 5 native validation
            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                return;
            }
            
            // Gather required data
            const email = document.getElementById('emailInput').value;
            const isSecurityAlertEnabled = checkbox.checked;
            
            // Construct the final data object for the Firebase call
            const data = {
                email: email,
                attributes: {
                    securityAlertEnabled: isSecurityAlertEnabled,
                }
            };
            
            // Add website URL if security alerts are enabled
            if (isSecurityAlertEnabled) {
                data.attributes.website = websiteInput.value;
            }
            
            // --- FIREBASE SUBMISSION LOGIC ---
            try {
                // Show loading state
                submitButton.disabled = true; 
                submitButton.textContent = 'Submitting...';
                
                // 📢 This is where your actual Firebase function will be called
                await firebase('subscribe', data); 

                window.tsTrack && window.tsTrack('newsletter_signup', {
                    form: 'newsletter',
                    security_alert: isSecurityAlertEnabled ? 'yes' : 'no'
                });
                
                // Close the modal after successful submission
                 modal.modal('hide');
                localStorage.setItem('noSubscribe', 1);
                
            } catch (error) {
                console.error('Subscription failed:', error);
                alert('Subscription failed. Please try again.');
            } finally {
                // Reset button state
                submitButton.disabled = false;
                submitButton.textContent = 'Subscribe';
            }
            
            form.classList.remove('was-validated');
        });
    }

    // 4. Conditional Modal Display
    
    if (optin) {
        showSubscribeModal();
    } else if (
        localStorage.getItem(storagekey) !== '1' &&
        window.location.pathname !== '/' &&
        window.location.pathname !== '/about-us' &&
        window.location.pathname !== '/services' &&
        !window.location.pathname.startsWith('/campaign/try-moodle-503') &&
        !window.location.pathname.startsWith('/tools/try-moodle-503')
    ) {
        setTimeout(() => {
           showSubscribeModal();
        }, 60000);
    }

    $('#emailSubChangeEmail').on('click', () => {
        $('#emailSubEmailInput').show(800);
        $('#emailSubEmailCnt, #emailSubChangeEmail').hide(800);
    })

     $('#emailSubDiscard').on('click', () => {
        localStorage.setItem(storagekey, 1)
        modal.modal('hide');
    })
});

function showSubscribeModal() {
    $('#emailSubModal').modal('show');
}